import { render, staticRenderFns } from "./OffersBody.vue?vue&type=template&id=2cf9e57a&scoped=true"
import script from "./OffersBody.vue?vue&type=script&lang=js"
export * from "./OffersBody.vue?vue&type=script&lang=js"
import style0 from "./OffersBody.vue?vue&type=style&index=0&id=2cf9e57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9e57a",
  null
  
)

export default component.exports